/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { useState } from "react";

import { Col, Row } from "react-bootstrap";
import { isEmpty } from "lodash";

import { BoxContainer } from "../Company";

import CompanyHeader from "./CompanyHeader";
import AttributesBox from "./AttributesBox";

const AffinitySection = (props) => {
    const { company } = props;

    const data = {
        companyIndResidential: true,
        companyIndCommercial: true,
        companyIndIndustrial: true,
        companyIndExterior: true,
        companyIndInterior: true,
        companyIndLicensed: true,
        companyIndBonded: true,
        companyIndInsured: true,
        companyProfileCnt: 12,
        companyManufacturerCnt: 10,
        companyAssociationCnt: 10,
        companyLicenseCnt: 3,
        companyContactCnt: 5,
        companySourceCnt: 5
    };

    const [more, setMore] = useState(false);

    const affiliations = company.affiliations || [];
    const affinities = company.affinities || [];

    const companyServices = isEmpty(affiliations) ? [] : affiliations.split(',').map((info) => info.trim());
    const companyProfileServices = isEmpty(affinities) ? [] : affinities.split(',').map((info) => info.trim());

    const servicesData = companyServices && companyProfileServices && companyServices.concat(companyProfileServices);

    return (
        <BoxContainer>
            <CompanyHeader
                title={'Affinities & Affiliations'}
                showMore={Object.keys(data).length > 6}
                onShowMore={(v) => {
                    console.log(v);
                    setMore(v);
                }}
                more={more}
            />
            { servicesData && (
                <Row style={{
                    marginTop: 15,
                }}>
                    <Col xs={12}>
                        <AttributesBox item={servicesData} showMore={more} />
                    </Col>
                </Row>
            )}
        </BoxContainer>
    )
}

export default AffinitySection;
